import { useState } from 'react';
import { UseFormRegisterReturn, FieldError } from 'react-hook-form';

interface PapInputProps {
  formBinding: UseFormRegisterReturn;
  fieldName: string;
  required?: boolean;
  autocomplete?: boolean;
  type?: string;
  placeholder?: string;
  fieldLabel: string;
  error?: FieldError;
}

const PapInput: React.FC<PapInputProps> = ({ formBinding, fieldName, required = false, autocomplete, type = "text", placeholder, fieldLabel, error }) => {
  const [isFocused, setIsFocused] = useState(false);

  const autoCompleteValue = autocomplete !== undefined
    ? (autocomplete ? "on" : "off")
    : (type === "email" ? "email" : type === "password" ? "current-password" : undefined);

  return (
    <div className="mb-5">
      <label className="form-label" htmlFor={fieldName}>
        {fieldLabel}{required && <span className="text-destructive ml-1">*</span>}
      </label>
      <div className={`relative rounded-xl transition-all duration-200 ${isFocused ? 'ring-2 ring-accent/20' : ''}`}>
        <input {...formBinding}
          type={type}
          name={fieldName}
          id={fieldName}
          autoComplete={autoCompleteValue}
          placeholder={placeholder === undefined ? fieldLabel : placeholder}
          className={`form-input ${error ? 'border-destructive focus:border-destructive focus:ring-destructive/20' : ''}`}
          onFocus={() => {
            setIsFocused(true);
          }}
          onBlur={(e) => {
            setIsFocused(false);
            formBinding.onBlur(e);
          }}
        />
      </div>
      {error && (
        <p className="mt-1.5 text-sm text-destructive flex items-center gap-1">
          {error.message}
        </p>
      )}
    </div>
  );
};

export default PapInput;
